export const FETCH_AVAILABILITY_GENERIC = 'availabilityGeneric/FETCH';
export const FETCH_AVAILABILITY_GENERIC_SUCCESS = 'availabilityGeneric/FETCH_SUCCESS';
export const FETCH_AVAILABILITY_GENERIC_FAIL = 'availabilityGeneric/FETCH_FAIL';

/* eslint-disable */
const AvailabilityGenericReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_AVAILABILITY_GENERIC_SUCCESS:
      if (action.payload.response && action.payload.response.length) {
        let newState = {}
        action.payload.response.forEach(({ response, sku }) => {
          const { available: isAvailable, ...price } = response.data[0];
          newState[sku] = {
            isLoading: false,
            isAvailable,
            isPriceUpdated: true,
            isLoaded: true,
            discountRateCash: price && price.cash && price.cash.discountRateCash,
            discountRate: price && price.discountRate,
            ...(isAvailable && { price }),
          }
        })
        return {
          ...state,
          ...newState,
        };
      }
      break;
    case FETCH_AVAILABILITY_GENERIC_FAIL:
      return {
        ...state,
        [action.payload.sku]: {
          isLoading: false,
          isAvailable: false,
          isPriceUpdated: true,
        },
      };
    default:
      return { ...state };
  }
};

export default AvailabilityGenericReducer;
